(function () {
  const SEARCH_CARD_SECTION = 'algolia-search-product-card';
  const PREDICTIVE_CARD_SECTION = 'algolia-predictive-product-card';
  const DEFAULT_SEARCH_LIMIT = 24;
  const cardCache = new Map();
  let activeSearchRun = 0;
  let scheduledInit = 0;
  let activeLoadMore = null;

  function config() {
    return window.Theme && window.Theme.algolia ? window.Theme.algolia : {};
  }

  function isEnabled() {
    const algolia = config();

    return Boolean(
      algolia.enabled &&
        algolia.applicationId &&
        algolia.searchApiKey &&
        algolia.productsIndex
    );
  }

  function parseJSONMap(value) {
    if (!value) return {};
    if (typeof value === 'object') return value;

    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (_error) {
      return {};
    }
  }

  function rootPath() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function text(key, fallback) {
    return window.Theme?.translations?.[key] || fallback;
  }

  function pluralKey(count) {
    try {
      return new Intl.PluralRules(document.documentElement.lang || undefined).select(count);
    } catch (_error) {
      return count === 1 ? 'one' : 'other';
    }
  }

  function interpolateCount(value, count) {
    return String(value).replace('__COUNT__', String(count));
  }

  function formatCount(kind, count) {
    if (kind === 'item' && count > 25000) {
      return interpolateCount(text('item_count_cutoff', 'More than __COUNT__ items'), 25000);
    }

    const key = `${kind}_count_${pluralKey(count)}`;
    const fallbackKey = count === 1 ? `${kind}_count_one` : `${kind}_count_other`;
    const fallback = kind === 'products'
      ? `${count} ${count === 1 ? 'product' : 'products'}`
      : `${count} ${count === 1 ? 'item' : 'items'}`;

    return interpolateCount(text(key, text(fallbackKey, fallback)), count);
  }

  function noResultsText(query) {
    return text('search_results_no_results', 'No results for "__QUERY__"').replace('__QUERY__', query);
  }

  function indexNameForCurrentSort(useURLState = true) {
    const algolia = config();
    if (!useURLState) return algolia.productsIndex;

    const sortBy = new URLSearchParams(window.location.search).get('sort_by') || '';
    const customMap = parseJSONMap(algolia.sortIndexMap);
    const defaultMap = {
      'price-ascending': `${algolia.productsIndex}_price_asc`,
      'price-descending': `${algolia.productsIndex}_price_desc`,
      'title-ascending': `${algolia.productsIndex}_title_asc`,
      'title-descending': `${algolia.productsIndex}_title_desc`,
      'created-ascending': `${algolia.productsIndex}_created_asc`,
      'created-descending': `${algolia.productsIndex}_created_desc`,
      'best-selling': `${algolia.productsIndex}_best_selling`,
    };

    return customMap[sortBy] || defaultMap[sortBy] || algolia.productsIndex;
  }

  function facetAttributeForParam(param) {
    const customMap = parseJSONMap(config().filterAttributeMap);
    if (customMap[param]) return customMap[param];

    if (param === 'filter.p.vendor') return 'vendor';
    if (param === 'filter.p.product_type') return 'product_type';
    if (param === 'filter.p.tag') return 'tags';
    if (param.startsWith('filter.v.option.')) return `options.${param.replace('filter.v.option.', '')}`;

    // Standardowe czyszczenie prefiksów Shopify + zamiana m.custom na meta.custom
    const cleaned = param.replace(/^filter\.[pv]\./, '');
    return cleaned.replace(/^m\.custom\./, 'meta.custom.');
  }

  function numberFromFilterValue(value) {
    const normalized = String(value || '')
      .replace(/\s/g, '')
      .replace(',', '.')
      .replace(/[^0-9.-]/g, '');
    const number = Number(normalized);

    return Number.isFinite(number) ? number : null;
  }

  function refinementListAttribute(param) {
    const match = String(param).match(/^refinementList\[([^\]]+)\]/);
    if (!match) return '';
    
    // Jeśli wyciągnięty atrybut zaczyna się od "m.custom.", zamień go na "meta.custom."
    return match[1].replace(/^m\.custom\./, 'meta.custom.');
  }

// POPRAWKA: Wymuszamy format ["Wartość"], jeśli wartość z URL została automatycznie oczyszczona
  function refinementListValues(value) {
    if (!value) return [];

    const stringValue = String(value).trim();

    // Jeśli wartość już ma format ["coś"], zwracamy ją bez zmian
    if (stringValue.startsWith('[') && stringValue.endsWith(']')) {
      return [stringValue];
    }

    // Jeśli wartość to czysty tekst (np. Wino białe), pakujemy ją w format wymagany przez Twój indeks Algolii
    return [`["${stringValue}"]`];
  }

  function algoliaFiltersFromURL(useURLState = true) {
    if (!useURLState) {
      return {
        facetFilters: [],
        numericFilters: [],
      };
    }

    const params = new URLSearchParams(window.location.search);
    const facetGroups = new Map();
    const numericFilters = [];

    for (const [param, value] of params.entries()) {
      if (!value) continue;

      const refinementAttribute = refinementListAttribute(param);
      if (refinementAttribute) {
        if (!facetGroups.has(refinementAttribute)) facetGroups.set(refinementAttribute, []);
        
        refinementListValues(value).forEach((refinementValue) => {
          // Tutaj łączymy atrybut z surową wartością (która ma już w sobie np. ["Wino białe"])
          facetGroups.get(refinementAttribute).push(`${refinementAttribute}:${refinementValue}`);
        });
        continue;
      }

      if (param === 'filter.v.price.gte') {
        const min = numberFromFilterValue(value);
        if (min != null) numericFilters.push(`price>=${min}`);
        continue;
      }

      if (param === 'filter.v.price.lte') {
        const max = numberFromFilterValue(value);
        if (max != null) numericFilters.push(`price<=${max}`);
        continue;
      }

      if (!param.startsWith('filter.')) continue;

      const attribute = facetAttributeForParam(param);
      if (!attribute) continue;

      if (!facetGroups.has(param)) facetGroups.set(param, []);
      facetGroups.get(param).push(`${attribute}:${value}`);
    }

    return {
      facetFilters: Array.from(facetGroups.values()).map((group) => (group.length === 1 ? group[0] : group)),
      numericFilters,
    };
  }

async function searchAlgolia(query, page, hitsPerPage, useURLState = true) {
    const algolia = config();
    const indexName = indexNameForCurrentSort(useURLState);
    const filters = algoliaFiltersFromURL(useURLState);
    const endpoint = `https://${algolia.applicationId}-dsn.algolia.net/1/indexes/${encodeURIComponent(
      indexName
    )}/query`;

    // --- POPRAWIONA KULOODPORNA METODA DLA FILTRÓW TEXT VS NUMBER ---
    if (filters.facetFilters && filters.facetFilters.length) {
      filters.facetFilters = filters.facetFilters.map(filter => {
        if (Array.isArray(filter)) {
          return filter.map(f => transformMetaFilter(f));
        }
        return transformMetaFilter(filter);
      });
    }

    function transformMetaFilter(filterString) {
      if (typeof filterString !== 'string') return filterString;
      
      if (filterString.startsWith('meta.custom.') && filterString.includes(':')) {
        const parts = filterString.split(':');
        const attribute = parts[0];
        let value = parts.slice(1).join(':').trim();

        // Lista pól z Twojego indeksu, które są zwykłymi stringami (liczbami), a nie tablicami
        const numericAttributes = [
          'meta.custom.pojemnosc',
          'meta.custom.wysokosc',
          'meta.custom.szerokosc_srednica'
        ];

        // Jeśli to jest pole liczbowe, usuwamy ewentualne nawiasy i wysyłamy czystą wartość (np. "35")
        if (numericAttributes.includes(attribute)) {
          if (value.startsWith('[') && value.endsWith(']')) {
            value = value.slice(1, -1).replace(/^"|"$/g, '');
          }
          return `${attribute}:${value}`;
        }

        // Dla wszystkich pozostałych pól (tekstowych) wymuszamy format ["Wartość"]
        if (!value.startsWith('["') && !value.endsWith('"]')) {
          value = `["${value}"]`;
        }

        return `${attribute}:${value}`;
      }
      return filterString;
    }
    // --- KONIEC POPRAWKI ---

    const searchParams = {
      query,
      page,
      hitsPerPage,
    };

    if (filters.facetFilters.length) {
      searchParams.facetFilters = filters.facetFilters;
    }

    if (filters.numericFilters.length) {
      searchParams.numericFilters = filters.numericFilters;
    }

    const queryString = Object.keys(searchParams)
      .map(key => {
        const value = typeof searchParams[key] === 'object' 
          ? JSON.stringify(searchParams[key]) 
          : String(searchParams[key]);
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      })
      .join('&');

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Algolia-API-Key': algolia.searchApiKey,
        'X-Algolia-Application-Id': algolia.applicationId,
      },
      body: JSON.stringify({ params: queryString }),
    });

    if (!response.ok) {
      throw new Error(`Algolia search failed: ${response.status}`);
    }

    return response.json();
  }

  function valueAtPath(object, path) {
    return String(path || '')
      .split('.')
      .reduce((value, key) => (value && value[key] != null ? value[key] : null), object);
  }

  function handleFromUrl(url) {
    if (!url) return '';

    try {
      const parsed = new URL(url, window.location.origin);
      const parts = parsed.pathname.split('/').filter(Boolean);
      const productIndex = parts.indexOf('products');

      return productIndex >= 0 ? parts[productIndex + 1] || '' : '';
    } catch (_error) {
      const match = String(url).match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    }
  }

  function handleFromHit(hit) {
    const algolia = config();
    const configuredHandle = valueAtPath(hit, algolia.handleAttribute);
    const candidates = [
      configuredHandle,
      hit.handle,
      hit.product_handle,
      hit.productHandle,
      hit.product?.handle,
      hit.shopify?.handle,
      handleFromUrl(hit.url),
      handleFromUrl(hit.product_url),
      handleFromUrl(hit.online_store_url),
      handleFromUrl(hit.onlineStoreUrl),
    ];

    return candidates.find((candidate) => typeof candidate === 'string' && candidate.trim())?.trim() || '';
  }

  function uniqueHandles(hits) {
    const seen = new Set();

    return hits
      .map(handleFromHit)
      .filter((handle) => {
        if (!handle || seen.has(handle)) return false;
        seen.add(handle);
        return true;
      });
  }

  async function fetchCard(handle, sectionId) {
    const cacheKey = `${sectionId}:${handle}`;
    if (cardCache.has(cacheKey)) return cardCache.get(cacheKey);

    const url = new URL(`${rootPath()}products/${encodeURIComponent(handle)}`, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    const promise = fetch(url.toString())
      .then((response) => {
        if (!response.ok) throw new Error(`Product card fetch failed: ${response.status}`);
        return response.text();
      })
      .then((html) => html.trim());

    cardCache.set(cacheKey, promise);
    return promise;
  }

  async function fetchCards(handles, sectionId) {
    const cards = await Promise.allSettled(handles.map((handle) => fetchCard(handle, sectionId)));

    return cards
      .filter((result) => result.status === 'fulfilled' && result.value)
      .map((result) => result.value);
  }

  function renderSearchEmpty(grid, query) {
    grid.innerHTML = `
      <li class="main-collection-grid__empty algolia-search__empty" role="status">
        <h2 class="main-collection-grid__empty-title h2">${text('no_products_found', 'No products found')}</h2>
        <p>${noResultsText(query)}</p>
      </li>
    `;
  }

  function updateLoadMore(root, shown, total, hasMore) {
    const count = root.querySelector('.product-grid__load-more-count');
    const container = root.querySelector('.product-grid__load-more');

    if (count) {
      count.innerHTML = `${text('pagination_show', 'Showing')} <span ref="loadMoreCountValue">${shown}</span> ${text(
        'pagination_of',
        'of'
      )} ${total} ${text('pagination_products', 'products')}`;
    }

    if (container) {
      container.hidden = !hasMore;
    }
  }

  function updateProductCounts(root, total) {
    root.querySelectorAll('.products-count-wrapper').forEach((wrapper) => {
      const span = wrapper.querySelector('span');
      if (!span) return;

      const kind =
        wrapper.classList.contains('products-count-wrapper--mobile') ||
        wrapper.classList.contains('products-count-wrapper--desktop')
          ? 'products'
          : 'item';

      span.textContent = formatCount(kind, total);
    });
  }

  function setSearchLoading(root, isLoading) {
    root.toggleAttribute('data-algolia-loading', isLoading);
  }

  function setSearchReady(root) {
    root.setAttribute('data-algolia-ready', '');
    root.removeAttribute('data-algolia-pending');
  }

  function initSearchPage() {
    if (!isEnabled()) return;

    const root = document.querySelector('[data-algolia-search-root]');
    if (!root || root.__algoliaSearchReady) return;

    const grid = root.querySelector('.product-grid');
    if (!grid) return;

    const query = new URLSearchParams(window.location.search).get('q')?.trim() || '';
    // if (!query) return;

    root.__algoliaSearchReady = true;

    const hitsPerPage = Number(root.dataset.algoliaHitsPerPage) || DEFAULT_SEARCH_LIMIT;
    const runId = ++activeSearchRun;
    const state = {
      page: 0,
      shown: 0,
      total: 0,
      query,
    };

    // Bridge przejmuje przycisk "Zobacz więcej" dopiero po udanej odpowiedzi z Algolii.
    // Dopóki tego nie zrobi, natywny load-more motywu zostaje nietknięty.
    // Oryginalna wartość on:click jest zapamiętana, żeby dało się ją przywrócić -
    // motyw rozwiązuje on:click dopiero w momencie kliknięcia (component.js, closest()).
    function takeOverLoadMore() {
      const button = root.querySelector('.product-grid__load-more-button');

      if (button?.hasAttribute('on:click')) {
        button.dataset.algoliaNativeClick = button.getAttribute('on:click');
        button.removeAttribute('on:click');
      }

      activeLoadMore = () => loadPage(state.page + 1, false);
    }

    // Powrót do natywnego load-more motywu, gdy Algolia jest niedostępna.
    function restoreNativeLoadMore() {
      activeLoadMore = null;

      const button = root.querySelector('.product-grid__load-more-button');

      if (button?.dataset.algoliaNativeClick) {
        button.setAttribute('on:click', button.dataset.algoliaNativeClick);
        delete button.dataset.algoliaNativeClick;
      }
    }

    async function loadPage(page, replace) {
      setSearchLoading(root, true);

      try {
        const results = await searchAlgolia(state.query, page, hitsPerPage);
        const handles = uniqueHandles(results.hits || []);
        const cards = await fetchCards(handles, SEARCH_CARD_SECTION);
        const currentRoot = document.querySelector('[data-algolia-search-root]');
        const currentGrid = currentRoot?.querySelector('.product-grid');

        if (runId !== activeSearchRun || currentRoot !== root || currentGrid !== grid) return;

        if (replace) {
          grid.innerHTML = '';
          state.shown = 0;
        }

        state.total = Number(results.nbHits) || 0;

        if (!cards.length && replace) {
          renderSearchEmpty(grid, state.query);
        } else {
          grid.insertAdjacentHTML('beforeend', cards.join(''));
          state.shown += cards.length;
        }

        state.page = page;
        updateProductCounts(root, state.total);
        updateLoadMore(root, state.shown, state.total, state.shown < state.total);
        takeOverLoadMore();
        setSearchReady(root);
      } catch (error) {
        console.error(error);

        if (replace) {
          // Pierwsze zapytanie padło (np. 403 - zablokowana aplikacja Algolia).
          // Oddajemy sterowanie natywnemu load-more motywu i zostawiamy wyniki
          // wyrenderowane serwerowo przez Shopify zamiast zabijać przycisk.
          console.warn('Algolia niedostępna - powrót do natywnego wyszukiwania Shopify.');
          restoreNativeLoadMore();
        }
        // Przy doładowywaniu kolejnej strony zostawiamy activeLoadMore, żeby klik
        // dało się ponowić - natywna paginacja jest w tym momencie nieaktualna.

        setSearchReady(root);
      } finally {
        setSearchLoading(root, false);
      }
    }

    activeLoadMore = null;
    loadPage(0, true);
  }

  function scheduleSearchPageInit() {
    window.clearTimeout(scheduledInit);
    scheduledInit = window.setTimeout(() => {
      const root = document.querySelector('[data-algolia-search-root]');
      if (root) {
        root.__algoliaSearchReady = false;
        root.setAttribute('data-algolia-pending', '');
        root.removeAttribute('data-algolia-ready');
      }
      initSearchPage();
    }, 120);
  }

  function scheduleSearchPageInitSoon() {
    window.requestAnimationFrame(() => {
      const root = document.querySelector('[data-algolia-search-root]');
      if (root) {
        root.__algoliaSearchReady = false;
        root.setAttribute('data-algolia-pending', '');
        root.removeAttribute('data-algolia-ready');
      }
      initSearchPage();
    });
  }

  function predictiveMarkup(cards, query, total) {
    if (!cards.length) {
      return `
        <div
          id="predictive-search-results"
          class="predictive-search-dropdown"
          role="listbox"
          aria-expanded="true"
          data-transition-container
        >
          <div class="predictive-search-results__inner" data-search-results>
            <p class="predictive-search-results__no-results">${noResultsText(query)}</p>
          </div>
        </div>
      `;
    }

    return `
      <div
        id="predictive-search-results"
        class="predictive-search-dropdown"
        role="listbox"
        aria-label="${text('search_results_resource_products', 'Products')}"
        aria-expanded="true"
        data-transition-container
      >
        <div class="predictive-search-results__inner" data-search-results>
          <div class="visually-hidden" role="status" aria-live="polite">${total}</div>
          <div id="predictive-search-products" class="predictive-search-results__products">
            <h4 id="predictive-search-products-heading" class="predictive-search-results__title">
              ${text('search_results_resource_products', 'Products')}
            </h4>
            <ul
              class="predictive-search-results__list predictive-search-results__wrapper-products list-unstyled"
              role="listbox"
              aria-labelledby="predictive-search-products-heading"
            >
              ${cards.join('')}
            </ul>
          </div>
        </div>
      </div>
    `;
  }

  async function renderPredictiveResults(component, query) {
    if (!isEnabled()) return false;

    const limit = Number(config().predictiveProductsLimit) || 8;
    const container = component?.refs?.predictiveSearchResults;

    if (!container) return false;

    const results = await searchAlgolia(query, 0, limit, false);
    const handles = uniqueHandles(results.hits || []);
    const cards = await fetchCards(handles, PREDICTIVE_CARD_SECTION);

    container.innerHTML = predictiveMarkup(cards, query, Number(results.nbHits) || cards.length);
    container.querySelector('.predictive-search-results__inner')?.scrollTo(0, 0);

    return true;
  }

  window.AlgoliaSearchBridge = {
    initSearchPage,
    scheduleSearchPageInit,
    renderPredictiveResults,
  };

  const originalPushState = history.pushState;
  history.pushState = function (...args) {
    const result = originalPushState.apply(this, args);
    scheduleSearchPageInit();
    return result;
  };

  window.addEventListener('popstate', scheduleSearchPageInit);
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target?.closest('[data-algolia-search-root] .product-grid__load-more-button');

      if (!button || !activeLoadMore) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      activeLoadMore();
    },
    true
  );

  const observer = new MutationObserver(() => {
    if (document.querySelector('[data-algolia-search-root]:not([data-algolia-ready]):not([data-algolia-loading])')) {
      scheduleSearchPageInitSoon();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initSearchPage();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    initSearchPage();
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
